/**
 * The external dependencies.
 */
import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';
import * as R from "ramda";

/**
 * The internal dependencies.
 */
import {dispoStoreDepartments, dispoStoreDepartmentsConfig, dispoStoreUser} from './actions';
import {tasksDeselect} from "../tasks/actions";

const users = handleActions({
    [dispoStoreUser]: (state, {payload: {users}}) => {
        return R.pluck('content')(users._embedded.persistentEntityResources);
    }
}, []);

const departments = handleActions({
    [dispoStoreDepartments]: (state, {payload: {departments}}) => {
        if(R.isNil(departments._embedded)) return [];
        return R.pluck('content')(departments._embedded.persistentEntityResources);
    }
}, []);

const departmentsConfig = handleActions({
    [dispoStoreDepartmentsConfig]: (state, {payload: {departments}}) => {
        return R.uniq(R.pluck('departments', departments));
    },
    [tasksDeselect]: (state, {payload}) => {
        return [];
    }
}, []);


export default combineReducers({
    users,
    departments,
    departmentsConfig,
});



// WEBPACK FOOTER //
// ./src/store/dispo/reducer.js